
import { defineComponent } from "vue";
export default defineComponent({
  props: {
    skuName: {
      type: String,
      default: ""
    },
    vendorName: {
      type: String,
      default: ""
    },
    storageDesc: {
      type: String,
      default: ""
    },
    manufactureDate: {
      type: String,
      default: ""
    },
    productionLabels: {
      type: Array,
      default: () => {
        return [];
      }
    },
    // 显示新日期，循环productionLabels展示
    showNewDate: {
      type: Boolean,
      default: false
    },
    originName: {
      type: String,
      default: ""
    }
  }
});
